<script lang="ts">
  import type { Snippet } from 'svelte';

  const {
    header,
    body,
    openByDefault: defaultValue = false,
    closedBody,
    open,
  }: {
    header: Snippet<[boolean, (newValue: boolean) => void]>;
    body: Snippet;
    closedBody?: Snippet;
    openByDefault?: boolean;
    open?: boolean;
  } = $props();

  let isOpen = $state(defaultValue);
  $effect(() => {
    if (typeof open === 'boolean') {
      isOpen = open;
    }
  });
</script>

{@render header(isOpen, (newValue) => {
  isOpen = newValue;
})}
<div class={isOpen ? '' : 'hidden'}>
  {@render body()}
</div>
{#if closedBody}
  <div class={isOpen ? 'hidden' : ''}>
    {@render closedBody()}
  </div>
{/if}
